module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GX_3X.5c3a19d4.tom";